
import { defineComponent } from "vue";
import LogoAndName from '@/views/components/LogoAndName.vue';
import TaskStatusSelect from "../../components/task/TaskStatusSelect.vue";
import { store } from '@/store';
import UserSelection from "@/views/components/UserSelection/UserSelection.vue";
import SelectDate from "./SelectDate.vue";


export default defineComponent({
    components: {
        LogoAndName,
        TaskStatusSelect,
        UserSelection,
        SelectDate,
    },
    props: {
        task: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedUsers: [] as string[],
            dueDateEdit: false,
        }
    },
    computed: {
        formattedDueDate(): string {
            return this.task.dueDate ? new Date(this.task.dueDate).toLocaleDateString() : 'Set Due Date';
        },
        computedAccountablePerson: {
            get(): string[] {
                return [this.task.assignee];
            },
            set(v: any) {
                store.dispatch('task/updateTask', {
                    moduleId: this.task.moduleId,
                    taskId: this.task.taskId,
                    payload: {
                    ...this.task,
                    assignee: v[0]
                    }
                });
            },
        },
        computedDueDate: {
            get(): number {
                return this.task.dueDate;
            },
            set(v: any) {
                store.dispatch('task/updateTask', {
                    moduleId: this.task.moduleId,
                    taskId: this.task.taskId,
                    payload: {
                        ...this.task,
                        dueDate: v
                    },
                });
                this.dueDateEdit = false;
            },
        },
        computedStatus: {
            get(): string {
                return this.task.status;
            },
            set(v: any) {
                store.dispatch('task/updateTask', {
                    moduleId: this.task.moduleId,
                    taskId: this.task.taskId,
                    payload: {
                        ...this.task,
                        status: v
                    },
                });
            },
        }
    },
    methods: {
        openTaskSidebar(task: any) {
            store.commit('task/OPEN_TASK_SIDEBAR', task);
            const el = this.$refs["openModal"] as any;
            el.click();
        },
    },
});
